import ValueOfGoodsHSCode from './ValueOfGoodsHSCode'
import ValueOfGoodsHSCodeHeader from './ValueOfGoodsHSCodeHeader'
import ValueOfGoodsHSCodeHelp from './ValueOfGoodsHSCodeHelp'

export default {
  default: ValueOfGoodsHSCode,
  header: ValueOfGoodsHSCodeHeader,
  help: ValueOfGoodsHSCodeHelp,
}
